$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
BoardSelectOrganizationView = require 'app/scripts/views/board-menu/board-select-organization-view'
ChangeBoardAddMemberPermsView = require 'app/scripts/views/board-menu/change-board-add-member-perms-view'
ChangeBoardCommentingPermsView = require 'app/scripts/views/board-menu/change-board-commenting-perms-view'
ChangeBoardVotingPermsView = require 'app/scripts/views/power-ups/voting-settings-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class BoardSettingsView extends View
  viewTitleKey: 'settings'

  className: 'board-menu-content-frame'

  events:
    'click .js-change-org:not(.disabled)': 'changeOrg'

    'click .js-toggle-covers:not(.disabled)': 'toggleCovers'

    'click .js-change-comments:not(.disabled)': 'changeCommentingPerms'
    'click .js-change-voting:not(.disabled)': 'changeVotingPerms'
    'click .js-change-add-members:not(.disabled)': 'changeAddMemberPerms'

    'click .js-toggle-org-mem-join:not(.disabled)': 'toggleSelfJoin'

    'click .js-change-cookie-settings': 'changeCookieSettings'

  initialize: ({ @sidebarView }) ->
    @makeDebouncedMethods 'render'

    @listenTo @model, 'change', @renderDebounced

    @templateFlagEnabled = @sidebarView.templateFlagEnabled
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

    return

  render: ->
    data = @model.toJSON { prefs: true, url: true, labels: true }

    data.isLoggedIn = Auth.isLoggedIn()

    data.cardCovers = data.prefs.cardCovers
    organization = @model.getOrganization()
    data.orgDisplayName = organization?.get('displayName')
    data.hasOrg = organization?.id?

    data.votingEnabled = @model.isPowerUpEnabled('voting')
    data.commentsDisplay = l(['board pref perms', @model.getCommentPerm()])
    data.votingDisplay = l(['board pref perms', @model.getPref('voting')])
    data.invitationsDisplay = l(['board pref perms', @model.getInvitePerm()])

    # If you're the org owner, you can change the organization to nothing
    # If you're the board owner, you can change the organization to whatever
    data.canChangeOrg = organization?.owned() || @model.owned()

    if organization?.owned() && !@model.owned()
      data.setOrgNull = true

    data.templateModeEnabled = @model.isTemplate() && @templateFlagEnabled

    @$el.html(
      templates.fill(
        'board_menu_settings',
        data,
        { editable: @model.editable(), owned: @model.owned() }
      )
    )

    @

  changeOrg: (e) ->
    Util.stop(e)

    if @model.owned()

      PopOver.toggle
        elem: $(e.target).closest('a')
        view: BoardSelectOrganizationView
        options: { @model, @modelCache }

      track("Board Menu", "Settings", "Change Org")
      @sidebarView.sendClickedDrawerNavItemEvent('settings', 'changeOrg')

    else
      idOrg = @model.get('idOrganization')
      @modelCache.get('Organization', idOrg)?.boardList.remove(@model)
      @model.update 'idOrganization', ''
      PopOver.hide()
      track("Board Menu", "Settings", "Remove Org")
      @sidebarView.sendClickedDrawerNavItemEvent('settings', 'removeOrg')
    return

  toggleCovers: (e, cardCovers) ->
    Util.stop(e)

    @model.setPref('cardCovers', !@model.getPref('cardCovers'))

    track("Board Menu", "Settings", "Enable/Disable Cover Images")
    @sidebarView.sendClickedDrawerNavItemEvent(
      'settings',
      'cardCovers',
      { cardCoversEnabled: @model.getPref('cardCovers') }
    )
    return

  changeCommentingPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardCommentingPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Commenting Permissions")
    @sidebarView.sendClickedDrawerNavItemEvent('settings', 'commentPerms')
    return

  changeVotingPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardVotingPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Voting Permissions")
    @sidebarView.sendClickedDrawerNavItemEvent('settings', 'votingPerms')
    return

  changeAddMemberPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardAddMemberPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Add Member Permissions")
    @sidebarView.sendClickedDrawerNavItemEvent(
      'settings',
      'invitationsPerms',
      { invitationsEnabled: @model.getPref('invitations') }
    )
    return

  toggleSelfJoin: (e) ->
    Util.stop(e)

    @model.setPref('selfJoin', !@model.getPref('selfJoin'))
    @model.save()

    track("Board Menu", "Settings", "Toggle Allow Org Join")
    @sidebarView.sendClickedDrawerNavItemEvent(
      'settings',
      'selfJoin',
      { selfJoinEnabled: @model.getPref('selfJoin') }
    )
    return

  changeCookieSettings: ->
    trackUe('boards sidebar', 'opens', 'cookie settings')
    @sidebarView.sendClickedDrawerNavItemEvent('settings', 'cookieConsent')
    window.trelloCookieConsentDialog()
